// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_um-0";